import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue";
const _hoisted_1 = ["onKeyup"];
const _hoisted_2 = { class: "table" };
const _hoisted_3 = ["colspan"];
const _hoisted_4 = { class: "variants-matrix__options-x" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "variants-matrix__option-y-label" };
const _hoisted_8 = { class: "variants-matrix__option-y-number" };
const _hoisted_9 = { key: 0 };
import { computed } from 'vue';
import { useRoute } from "vue-router";
import ProductArticlesMatrixCell from "./ProductArticlesMatrixCell.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductArticlesMatrix',
    props: {
        matrix: {},
        variants: {}
    },
    emits: [
        'cart-input-change',
        'select-variant',
        'submit',
    ],
    setup(__props, { emit: __emit }) {
        const route = useRoute();
        const props = __props;
        const emit = __emit;
        const selectedOptionY = computed(findSelectedOptionY);
        const selectedOptionZ = computed(findSelectedOptionZ);
        const zOptions = computed(() => {
            if (props.matrix.optionZ) {
                return props.matrix.optionZ.values;
            }
            // create 'fake' Z-option
            return [{
                    value: '__none__',
                    label: '',
                    skus: [],
                    image: null,
                }];
        });
        function findVariant(option1, option2, option3) {
            // find SKU(s) present in all options (usually 1)
            let skus = option1.skus.filter(sku => option2.skus.includes(sku));
            if (option3) {
                skus = skus.filter(sku => option3.skus.includes(sku));
            }
            return props.variants.filter(variant => skus.includes(variant.sku))[0];
        }
        function onCartInputChange(itemDraft) {
            emit('cart-input-change', itemDraft);
        }
        function selectMatrixRow(optionY, optionZ) {
            let variant;
            if (optionZ) {
                variant = findVariant(optionY, optionZ);
            }
            else {
                const sku = optionY.skus[0];
                variant = props.variants.find(variant => variant.sku === sku);
            }
            emit('select-variant', variant);
        }
        function submit() {
            emit('submit');
        }
        /**
         * Finds the shared SKU prefix for the given option.
         */
        function optionNumber(option) {
            if (!option.skus[0] || option.skus.length == 1) {
                return option.skus[0] || '';
            }
            let i = 0;
            while (option.skus[0][i] && option.skus.every(w => w[i] === option.skus[0][i])) {
                i++;
            }
            return (option.skus)[0].substring(0, i)
                .replace(/[- _]$/, '');
        }
        function findSelectedOption(option) {
            // @ts-ignore
            const sku = route.params['sku'];
            if (!sku) {
                return null;
            }
            const variant = props.variants.find(variant => variant.sku === sku);
            if (!variant) {
                return null;
            }
            const value = option.values.find(v => v.skus.includes(sku));
            return value?.value || null;
        }
        function findSelectedOptionY() {
            return findSelectedOption(props.matrix.optionY);
        }
        function findSelectedOptionZ() {
            const option = props.matrix.optionZ;
            if (!option) {
                return null;
            }
            return findSelectedOption(option);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["variants-matrix", { 'variants-matrix--with-options-z': __props.matrix.optionZ }]),
                onKeyup: _withKeys(_withModifiers(submit, ["exact"]), ["enter"])
            }, [
                _createElementVNode("table", _hoisted_2, [
                    _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", {
                                colspan: __props.matrix.optionZ ? 2 : 1
                            }, null, 8, _hoisted_3),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            _createElementVNode("th", null, _toDisplayString(__props.matrix.optionX.label), 1)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("tr", _hoisted_4, [
                            _createElementVNode("th", null, _toDisplayString(__props.matrix.optionY.label), 1),
                            _cache[1] || (_cache[1] = _createTextVNode()),
                            (__props.matrix.optionZ)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_5, _toDisplayString(__props.matrix.optionZ.label), 1))
                                : _createCommentVNode("", true),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.matrix.optionX.values, (optionX) => {
                                return (_openBlock(), _createElementBlock("th", {
                                    key: optionX.value,
                                    class: "variants-matrix__option-x"
                                }, _toDisplayString(optionX.label), 1));
                            }), 128))
                        ])
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.matrix.optionY.values, (optionY) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                                key: optionY.value
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zOptions.value, (optionZ, index) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                        key: optionZ.value,
                                        onClick: _withModifiers(($event) => (selectMatrixRow(optionY, __props.matrix.optionZ ? optionZ : undefined)), ["prevent"]),
                                        class: _normalizeClass(["variants-matrix__options-y", {
                                                'variants-matrix__options-y--selected': selectedOptionY.value === optionY.value && (!selectedOptionZ.value || optionZ.value == selectedOptionZ.value),
                                                'variants-matrix__options-z--first': index === 0
                                            }])
                                    }, [
                                        _createElementVNode("td", null, [
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(optionY.label), 1),
                                            _cache[4] || (_cache[4] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(optionNumber(optionY)), 1)
                                        ]),
                                        _cache[5] || (_cache[5] = _createTextVNode()),
                                        (__props.matrix.optionZ)
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_9, _toDisplayString(optionZ.label), 1))
                                            : _createCommentVNode("", true),
                                        _cache[6] || (_cache[6] = _createTextVNode()),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.matrix.optionX.values, (optionX) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                                key: optionX.value
                                            }, [
                                                _createVNode(ProductArticlesMatrixCell, {
                                                    variant: findVariant(optionX, optionY, __props.matrix.optionZ ? optionZ : undefined),
                                                    onChange: onCartInputChange
                                                }, null, 8, ["variant"])
                                            ]));
                                        }), 128))
                                    ], 10, _hoisted_6));
                                }), 128))
                            ], 64));
                        }), 128))
                    ])
                ])
            ], 42, _hoisted_1));
        };
    }
});
